import React from 'react';

const GeorgeIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" className={className} aria-hidden="true">
    <path d="M4 34V44H14"/>
    <path d="M34 44H44V34"/>
    <path d="M34 4H44V14"/>
    <path d="M14 4H4V14"/>
    <path d="M16 34C16 34 19 37 24 37C29 37 32 34 32 34"/>
    <path d="M24 14V23C24 25 22 27 20 27H19"/>
    <path d="M34 14V16"/>
    <path d="M14 14V16"/>
  </svg>
);

export default GeorgeIcon;
